import React from "react";
import { bool } from "prop-types";
import ProductInfo from "./_components/ProductInfo";

const CustomHeadTitle = (props) => {
    const { account, isDesktop } = props;
    const { number, productAlias } = account;

    return (
        <>
            {(isDesktop && (
                <div className="toolbar-item view-title">
                    <ProductInfo account={account} />
                </div>
            )) || (
                <div className="toolbar-item view-title">
                    <h1 className="ellipsis">{productAlias || number}</h1>
                </div>
            )}
        </>
    );
};

CustomHeadTitle.propTypes = {
    isDesktop: bool.isRequired,
    ...ProductInfo.propTypes,
};

export default CustomHeadTitle;
